import { CourseType } from '../api/models/Course';
import { colors } from '../Styles';

export const getCourseColor = (course: CourseType) => {
  switch (course) {
    case 'ARTS':
      return colors.arts;
    case 'SCIENCE':
      return colors.science;
    case 'HEALTH':
      return colors.health;
    case 'MATH':
      return colors.math;
    case 'ELECTIVES':
      return colors.electives;
    case 'LANGUAGE_ARTS':
      return colors.languageArts;
    case 'PE':
      return colors.pe;
    case 'SOCIAL_STUDIES':
      return colors.socialStudies;
    default:
      return colors.grayLight;
  }
};

export const getNeededCourseColor = (course: CourseType) => {
  switch (course) {
    case 'ARTS':
      return colors.artsLight;
    case 'SCIENCE':
      return colors.scienceLight;
    case 'HEALTH':
      return colors.healthLight;
    case 'MATH':
      return colors.mathLight;
    case 'ELECTIVES':
      return colors.electivesLight;
    case 'LANGUAGE_ARTS':
      return colors.languageArtsLight;
    case 'PE':
      return colors.peLight;
    case 'SOCIAL_STUDIES':
      return colors.socialStudiesLight;
    default:
      return colors.grayLight;
  }
};
